<template>
  <div class="login hero is-info is-fullheight" style="height:100%">
  <div class="container">
    <div class="row  justify-content-center" style="height:500px">
      <div class="col-md-4 align-self-end">
        <div class="mt-2"><p-button block variant="primary" @click.native="googleLogin">Login with Google</p-button></div>
      </div>
    </div>
  </div>
  </div>
</template>
<style>
.mt-2 {
  margin-top: 2px;
}
</style>

<script>
import firebase from 'firebase/app'
import router from '../router'

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      showError: false
    }
  },
  methods: {
    googleLogin() {
      const provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(
            provider.setCustomParameters({
                hd: "precena.com",
                prompt: "consent"
            })
         )
        .then(result => {
        console.log(result.user)
        router.push('/')
      }).catch(error => {
        console.log(error)
        this.errorMessage = error.message
        this.showError = true
      })
    },
    logOut(){
        firebase.auth().signOut()
    }
  }
}
</script>